import { T, useGT } from 'gt-react';
import { SplitHorizontalIcon } from '@phosphor-icons/react';
import {
  countSplitSuggestions,
  type SplitProposalLineInput,
} from './splitProposalCardData';

/**
 * The label of the Related lines tab. A small icon shows when a line has a
 * split suggestion, so AP knows there is something to review there.
 */
export function RelatedLinesTabLabel({
  lineItems,
}: {
  lineItems: readonly SplitProposalLineInput[];
}) {
  const gt = useGT();
  const suggestions = countSplitSuggestions(lineItems);
  return (
    <span className="flex items-center gap-1.5">
      <T context="AP invoice tab listing every line on the load, order and PO the invoice is matched to">
        Related lines
      </T>
      {suggestions > 0 && (
        <SplitHorizontalIcon
          className="h-3.5 w-3.5 text-sky-600 dark:text-sky-300"
          aria-label={gt('A split suggestion needs review', {
            context: 'icon on the Related lines tab of an AP invoice',
          })}
        />
      )}
    </span>
  );
}
